function CopyIco({ size, stroke }) {
  return (
    <svg
      width={size || "20"}
      height={size || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66602 6.66663V4.33329C6.66602 3.39987 6.66602 2.93316 6.84767 2.57664C7.00746 2.26304 7.26243 2.00807 7.57603 1.84828C7.93255 1.66663 8.39926 1.66663 9.33268 1.66663H15.666C16.5994 1.66663 17.0661 1.66663 17.4227 1.84828C17.7363 2.00807 17.9912 2.26304 18.151 2.57664C18.3327 2.93316 18.3327 3.39987 18.3327 4.33329V10.6666C18.3327 11.6 18.3327 12.0668 18.151 12.4233C17.9912 12.7369 17.7363 12.9918 17.4227 13.1516C17.0661 13.3333 16.5994 13.3333 15.666 13.3333H13.3327M4.33268 18.3333H10.666C11.5994 18.3333 12.0661 18.3333 12.4227 18.1516C12.7363 17.9918 12.9912 17.7369 13.151 17.4233C13.3327 17.0668 13.3327 16.6 13.3327 15.6666V9.33329C13.3327 8.39987 13.3327 7.93316 13.151 7.57664C12.9912 7.26304 12.7363 7.00807 12.4227 6.84828C12.0661 6.66663 11.5994 6.66663 10.666 6.66663H4.33268C3.39926 6.66663 2.93255 6.66663 2.57603 6.84828C2.26243 7.00807 2.00746 7.26304 1.84767 7.57664C1.66602 7.93316 1.66602 8.39987 1.66602 9.33329V15.6666C1.66602 16.6 1.66602 17.0668 1.84767 17.4233C2.00746 17.7369 2.26243 17.9918 2.57603 18.1516C2.93255 18.3333 3.39926 18.3333 4.33268 18.3333Z"
        stroke={stroke || "#7F56D9"}
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default CopyIco;
